import { Injectable } from '@angular/core';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { SaleRegistryExportQuery, SaleRegistryExportQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SaleRegistryExportQuery)
@Wrapper(SaleRegistryExportQueryHandlerBase)
export class SaleRegistryExportQueryHandler {
    public constructor(
        http: Http
    ) { }
}
